<app-register
  [selectedApps]="productSelection.selectedApps"
  (goBack)="goBack()">
</app-register>
